"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = exports.updateStatus = exports.BRAZE_UPDATE_STATUS = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios2 = _interopRequireDefault(require("axios"));

var _ajax = require("./ajax");

var BRAZE_UPDATE_STATUS = 'BRAZE::UDPATE';
exports.BRAZE_UPDATE_STATUS = BRAZE_UPDATE_STATUS;
var BRAZE_UDPATE_CONTEXT = "/service-braze/secure/application/status/update";
var BRAZE_UDPATE_HELOC_CONTEXT = "".concat(BRAZE_UDPATE_CONTEXT, "/heloc"); // TODO: update endpoint when other productType (i.e. cashout) is available

var updateStatus = function updateStatus(status, app_uuid, productType) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxPost)(BRAZE_UPDATE_STATUS, dispatch, "".concat((0, _ajax.baseUrl)()).concat(BRAZE_UDPATE_HELOC_CONTEXT), {
                status: status,
                app_uuid: app_uuid
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}; // Directly track events through braze API


exports.updateStatus = updateStatus;

var trackEvent = function trackEvent(apiKey, event, appId) {
  var headers = {
    'Content-Type': 'application/json',
    Authorization: "Bearer ".concat(apiKey)
  };
  return _axios2["default"].post('https://rest.iad-03.braze.com/users/track', {
    events: [{
      external_id: appId,
      name: event,
      time: new Date().toISOString()
    }]
  }, {
    headers: headers
  });
};

exports.trackEvent = trackEvent;